import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApplicantDetailsUrl } from "../utils/urlHelper";

const applicantDetailPageApi = createApi({
  reducerPath: "applicantDetail",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    oldKycDocument: builder.mutation({
      query: (body) => ({
        url: getApplicantDetailsUrl("old_kyc_documents"),
        method: "POST",
        body,
      }),
    }),

    faceMatch: builder.mutation({
      query: (body) => ({
        url: getApplicantDetailsUrl("face_match"),
        method: "POST",
        body,
      }),
    }),

    bankDetailPennyDrop: builder.mutation({
      query: (body) => ({
        url: getApplicantDetailsUrl("bank_detail_penny_drop"),
        method: "POST",
        body,
      }),
    }),

    getHvToken: builder.query({
      query: () => ({
        url: getApplicantDetailsUrl("hv_token"),
        method: "GET",
      }),
    }),
  }),
});

export const {
  useOldKycDocumentMutation,
  useBankDetailPennyDropMutation,
  useGetHvTokenQuery,
  useFaceMatchMutation,
} = applicantDetailPageApi;

export { applicantDetailPageApi };
